import { render, staticRenderFns } from "./VisualBlock.vue?vue&type=template&id=79da8b28&scoped=true"
import script from "./VisualBlock.vue?vue&type=script&lang=js"
export * from "./VisualBlock.vue?vue&type=script&lang=js"
import style0 from "./VisualBlock.vue?vue&type=style&index=0&id=79da8b28&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79da8b28",
  null
  
)

export default component.exports